var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 469.344 469",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M368.219 299.27c-5.461 0-10.922-2.09-15.082-6.25-8.344-8.34-8.344-21.825 0-30.165l43.093-43.093c19.649-19.457 30.442-45.442 30.442-73.239 0-57.152-46.508-103.68-103.68-103.68-27.777 0-53.762 10.794-73.172 30.38l-43.16 43.156c-8.34 8.344-21.824 8.344-30.164 0-8.34-8.34-8.34-21.824 0-30.164l43.094-43.113C247.023 15.453 283.762.176 322.992.176c80.703 0 146.348 65.644 146.348 146.347 0 39.274-15.278 75.989-43.031 103.489L383.28 293.02a21.229 21.229 0 0 1-15.062 6.25zM146.352 469.512C65.648 469.512.004 403.867.004 323.164c0-39.273 15.277-75.988 43.031-103.488l43.028-43.008c8.343-8.34 21.824-8.34 30.167 0 8.34 8.34 8.34 21.824 0 30.164l-43.093 43.094c-19.672 19.457-30.465 45.441-30.465 73.238 0 57.152 46.508 103.68 103.68 103.68 27.777 0 53.761-10.793 73.171-30.38l43.16-43.155c8.34-8.344 21.825-8.344 30.165 0 8.34 8.34 8.34 21.824 0 30.164l-43.094 43.117c-27.434 27.644-64.168 42.922-103.402 42.922zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.898 210.95c-5.46 0-10.921-2.09-15.082-6.25-8.34-8.34-8.34-21.825 0-30.165l40.106-40.105c8.344-8.344 21.824-8.344 30.168 0 8.34 8.34 8.34 21.824 0 30.164l-40.11 40.105a21.273 21.273 0 0 1-15.082 6.25zM149.34 341.512c-5.461 0-10.926-2.09-15.082-6.25-8.344-8.344-8.344-21.824 0-30.168l40.105-40.106c8.34-8.34 21.825-8.34 30.164 0 8.344 8.34 8.344 21.825 0 30.164l-40.105 40.11a21.273 21.273 0 0 1-15.082 6.25zM448.004 469.512c-5.461 0-10.922-2.09-15.082-6.25L6.258 36.594c-8.344-8.34-8.344-21.824 0-30.164 8.34-8.344 21.82-8.344 30.164 0L463.09 433.094c8.34 8.344 8.34 21.824 0 30.168a21.282 21.282 0 0 1-15.086 6.25zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.d05caed736b8a231af6e585f88f51fd6.svg";
export { ForwardRef as ReactComponent };